<div class="ubs-relation-list-container">
    <div class="detail-container" style="flex:2">
        <ubs-relation-form-container [addForm]="addForm" [parameters]="parameters" [addContainerTitle]="addContainerTitle" [lookupFieldResult]="lookupFieldResult" [appContext]="appContext" (refreshList)="refreshRelatedLists($event)" [selectedValue]="selectedValue"></ubs-relation-form-container>
    </div>
    <div class="master-container" style="flex:3">
        <ng-container *ngIf="!noList">
            <ubs-relation-list-container [listForm]="listForm" [parameters]="parameters" [title]="listContainerTitle" [addForm]="addForm" [appContext]="appContext"></ubs-relation-list-container>
        </ng-container>
    </div>
</div>





